import React from 'react';

const DeleteAccount = () => {
  return (
    <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto', fontFamily: 'sans-serif', color: '#333' }}>
      <h1 style={{ color: '#111827' }}>Eliminación de cuenta y datos - Oraculo Portal</h1>
      
      <p>En <strong>Oraculo Portal</strong>, nos tomamos tu privacidad muy en serio. Si decides que ya no deseas utilizar nuestra plataforma, tienes derecho a solicitar la eliminación completa de tu cuenta y los datos asociados.</p>

      <h2 style={{ fontSize: '1.5rem', marginTop: '2rem' }}>Cómo solicitar la eliminación</h2>
      <p>Para procesar tu solicitud, sigue estos pasos:</p>
      
      <ol style={{ lineHeight: '1.8' }}>
        <li>Envía un correo electrónico a <strong>gustavonahuelaguiar@gmail.com</strong>.</li>
        <li>Utiliza como asunto: <strong>"Solicitud de eliminación de cuenta - Oraculo Portal"</strong>.</li>
        <li>Incluye en el cuerpo del mensaje el correo electrónico asociado a tu cuenta para que podamos localizarla.</li>
      </ol>

      <h2 style={{ fontSize: '1.5rem', marginTop: '2rem' }}>¿Qué ocurre con tus datos?</h2>
      <ul style={{ lineHeight: '1.8' }}>
        <li><strong>Datos personales:</strong> Tras confirmar tu identidad, eliminaremos permanentemente tu perfil, tu historial de lecturas y cualquier información de configuración personal.</li>
        <li><strong>Información de pagos:</strong> Si has realizado compras dentro de la aplicación, es posible que mantengamos registros de facturación por el tiempo legal requerido para cumplir con obligaciones contables y fiscales.</li>
        <li><strong>Plazo de respuesta:</strong> Procesaremos tu solicitud en un plazo máximo de 7 días hábiles y te notificaremos por correo electrónico una vez que la eliminación sea efectiva.</li>
      </ul>

      <hr style={{ margin: '3rem 0', borderColor: '#e5e7eb' }} />
      <p style={{ fontSize: '0.9rem', color: '#6b7280' }}>
        Si tienes alguna duda sobre este proceso o sobre cómo tratamos tu información, no dudes en escribirnos al mismo correo electrónico.
      </p>
    </div>
  );
};

export default DeleteAccount;